import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import IQMDetailsCard from './components/IQMDetailsCard';
import { requestIQM, requestPTOList } from 'actionCreators';
import { getRole } from '../../../../reducers';
import connectUI from 'redux-ui';
import MessageBox from 'components/MessageBox';
import IQMType from 'types/iqm';
import PTOType from 'types/pto';
import { RoleType } from 'types/user';

class IQMDetails extends Component {
  static propTypes = {
    updateUI: PropTypes.func,
    requestIQM: PropTypes.func,
    requestPTOList: PropTypes.func,
    iqm: IQMType,
    loading: PropTypes.bool,
    ui: PropTypes.object,
    role: PropTypes.string,
    id: PropTypes.number,
    ptos: PropTypes.arrayOf(PTOType),
    user: RoleType,
  }

  componentDidMount() {
    if (!this.props.iqm) {
      this.props.requestIQM(this.props.id);
    }

    this.props.requestPTOList(this.props.id, 'iqms');
  }

  componentWillUnmount() {
    if (this.props.ui.successMessage) {
      this.props.updateUI('successMessage', '');
    }
  }

  handleTabChange = (index) => {
    this.props.updateUI('activeTab', index);
  }

  render() {
    const { iqm, loading, ui, role, ptos, user } = this.props;

    const iqmCard = (
      <IQMDetailsCard
        iqm={iqm}
        role={role}
        ptos={ptos}
        activeTab={ui.activeTab}
        onTabChange={this.handleTabChange}
        user={user}
      />
    );

    const container = !loading ? iqmCard : <p>Loading...</p>;

    return (
      <div>
        {ui.successMessage ? <MessageBox message={ui.successMessage} /> : null}
        {container}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const id = Number(ownProps.params.id);
  const iqm = state.iqms.details.id === id ? state.iqms.details : null;
  return {
    id,
    iqm,
    loading: !iqm || state.iqms.common.loading,
    role: getRole(state),
    ptos: state.ptos.data,
    user: state.user,
  };
};

export default connectUI()(connect(
  mapStateToProps, { requestIQM, requestPTOList },
)(IQMDetails));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/iqms/IQMDetails.jsx